/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PrepareGoogleImportDto
 */
export interface PrepareGoogleImportDto {
    /**
     * XLSX file content as base64 string
     * @type {string}
     * @memberof PrepareGoogleImportDto
     */
    fileContent: string;
    /**
     * Client ID
     * @type {string}
     * @memberof PrepareGoogleImportDto
     */
    clientId: string;
}

/**
 * Check if a given object implements the PrepareGoogleImportDto interface.
 */
export function instanceOfPrepareGoogleImportDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "fileContent" in value;
    isInstance = isInstance && "clientId" in value;

    return isInstance;
}

export function PrepareGoogleImportDtoFromJSON(json: any): PrepareGoogleImportDto {
    return PrepareGoogleImportDtoFromJSONTyped(json, false);
}

export function PrepareGoogleImportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrepareGoogleImportDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileContent': json['fileContent'],
        'clientId': json['clientId'],
    };
}

export function PrepareGoogleImportDtoToJSON(value?: PrepareGoogleImportDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fileContent': value.fileContent,
        'clientId': value.clientId,
    };
}

